<div class="flex flex-col gap-0.5 pb-2" [formGroup]="form()">
  @if (label()) {
    <label [for]="id()" class="font-medium text-tertiary pt-2 pl-1.5">
      {{ label() }}
      @if (required()) {
        <span class="text-red-600">*</span>
      }
    </label>
  }

  <div #trigger class="flex items-center relative rounded-md bg-gray-100 h-12">
    <input
      #inputElement
      [id]="id()"
      type="text"
      class="w-full h-full rounded-md outline-none p-3 text-base font-normal text-tertiary cursor-pointer appearance-none pr-9 truncate focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-1"
      [placeholder]="placeholder()"
      [value]="selectedLabel()"
      [required]="required()"
      [class.bg-lightZinc]="readonly()"
      (click)="readonly() ? null : toggleDropdown()"
      readonly />

    <img
      src="assets/icons/arrow-down.svg"
      alt="Dropdown Icon"
      width="23"
      height="23"
      [class]="
        'absolute right-2 top-1/2 transform -translate-y-1/2 pointer-events-none ' +
        (overlayRef() ? 'rotate-180' : 'rotate-0')
      " />
  </div>

  <ng-template #dropdownTemplate>
    <ul
      class="bg-white border rounded-md max-h-60 overflow-auto shadow-xl w-full text-base z-50">
      @if (showSearch()) {
        <li class="px-4 py-2">
          <input
            type="text"
            [ngModel]="searchTerm()"
            (ngModelChange)="searchTerm.set($event)"
            [ngModelOptions]="{ standalone: true }"
            (keydown.enter)="handleEnter($event)"
            placeholder="{{ 'PESQUISAR' | translate }}"
            class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm outline-none focus:ring-2 focus:ring-primary" />
        </li>
      }

      @if (control().value !== null) {
        <li
          (click)="clearSelection()"
          class="px-4 py-2 cursor-pointer hover:bg-gray-200 text-red-600">
          {{ 'LIMPAR_SELECAO' | translate }}
        </li>
      }

      @for (option of filteredOptions(); track option.value) {
        <li
          (click)="selectOption(option)"
          [class]="
            'px-4 py-2 cursor-pointer hover:bg-gray-100 flex items-center ' +
            (option.img ? 'gap-2' : '')
          ">
          @if (option.color) {
            <span
              [style.background-color]="option.color"
              class="status-circle mr-2 w-3 h-3 rounded-full block"></span>
          }
          @if (option.img) {
            <img [src]="option.img" [alt]="option.label" class="w-6 h-6" />
          }
          {{ labelMap()[option.label] || option.label }}
        </li>
      }

      @if (filteredOptions().length === 0) {
        <li class="px-4 py-2 text-gray-500">
          {{ 'NENHUMA_OPCAO_ECONTRADA' | translate }}
        </li>
      }
    </ul>
  </ng-template>

  @if (control().invalid && control().touched) {
    <div class="text-red-600 text-xs">
      <app-errors
        [formcontrolname]="controlName()"
        [form]="form()"></app-errors>
    </div>
  }
</div>
